module.exports = __webpack_public_path__ + "img/sample-report-09@3x.0d7e24d2.png";